import CurriculumProgramLogo from "./CurriculumProgramLogo";
export default CurriculumProgramLogo;
